import {createRandomArray, createOrder} from '../moduls/utils.js';

const QUESTIONS_NUMBER = 10;
const questionsArray = createRandomArray(QUESTIONS_NUMBER);

const GAME_1 = [{
  id: 1,
  start: 'start',
  steps: {
    'start': {
      type: 'comment',
      imageSrc: './assets/photo/start.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">ПРОВЕРЬ, КАКОЙ ТЫ ДОРОЖНИК!</h2><p>Каждому из нас — водителю, пассажиру, пешеходу, важны безопасные и удобные дороги – с новым асфальтом, разметкой,  хорошим освещением и «умными» системами контроля трафика. Благодаря национальному проекту <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/bezopasnye-i-kachestvennye-avtomobilnye-dorogi?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">«Безопасные и качественные автомобильные дороги»</a> к 2024 году так и будет! А вот что мы знаем об истории дорог в России, расскажет тест!</p>`,
      specialClass: 'content__step_start',
      button: true,
      buttonText: 'Поехали!',
      next: '1',
    },
    '1': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-1.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Верстовые столбы можно считать первыми дорожными знаками. При каком русском царе или царице они впервые были установлены?</p>`,
      answers: [
        {
          title: 'При Екатерине II.',
          next: '1a'
        },
        {
          title: 'При царе Алексее Михайловиче.',
          next: '1b'
        },
        {
          title: 'При Петре I.',
          next: '1c'
        },
      ],
    },
    '1a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Верстовые столбы можно считать первыми дорожными знаками. При каком русском царе или царице они впервые были установлены?</p>`,
      answerList: [
        ['При Екатерине II.', 'selected'],
        ['При царе Алексее Михайловиче.', false],
        ['При Петре I.', false]],
      comment: `<p>Императрица, конечно, была новатором, фигурой яркой. Но она уже усовершенствовала верстовые каменные столбы, стоящие на всех главных дорогах. Они стали 10-метровыми, а наверху их венчал флюгер в виде лошади. Первенство принадлежит не ей.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '1',
    },
    '1b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Верстовые столбы можно считать первыми дорожными знаками. При каком русском царе или царице они впервые были установлены?</p>`,
      answerList: [
        ['При Екатерине II.', false],
        ['При царе Алексее Михайловиче.', 'selected'],
        ['При Петре I.', false]],
      comment: `<p>В точку! Царя Алексея Михайловича называли Тишайшим. Но именно ему мы обязаны выражением «Коломенская верста». Когда в 1667 году строилась загородная резиденция в Коломенском, он распорядился по дороге от Калужской заставы до нового дворца установить 4-метровые каменные столбы. В дальнейшем на них стали указывать расстояние между городами.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '2',
    },
    '1c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-1c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Верстовые столбы можно считать первыми дорожными знаками. При каком русском царе или царице они впервые были установлены?</p>`,
      answerList: [
        ['При Екатерине II.', false],
        ['При царе Алексее Михайловиче.', false],
        ['При Петре I.', 'selected']],
      comment: `<p>Вы ошиблись. Понятно, что образ царя-реформатора у нас в головах еще со школы. Как же, создал регулярную армию и флот, брил бороды боярам, велел носить европейское платье, но запретил белиться. «Широк человек, слишком широк, я бы сузил…» – сказал позже про него Достоевский. Но вот с верстовыми столбами он пролетел. Это было сделано до него.</p>
      `,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '1',
    },

    '2': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-2.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Спецсигналы в дореволюционной России, которые были установлены на пожарных и полицейских машинах, а также на фельдъегерских тройках, звучали как...</a></p>`,
      answers: [
        {
          title: 'Электровибрационный сигнал, получивший прозвище «кукушка».',
          next: '2a'
        },
        {
          title: 'Особый звон колокольчиков.',
          next: '2b'
        },
        {
          title: 'Медный гудок с резиновой «грушей».',
          next: '2c'
        },
      ],
    },
    '2a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Спецсигналы в дореволюционной России, которые были установлены на пожарных и полицейских машинах, а также на фельдъегерских тройках, звучали как...</a></p>`,
      answerList: [
        ['Электровибрационный сигнал, получивший прозвище «кукушка».', 'selected'],
        ['Особый звон колокольчиков.', false],
        ['Медный гудок с резиновой «грушей».', false],
      ],
      comment: `<p>Ошибочка вышла! Эти сигналы были установлены на правительственных ЗИСах уже после войны. Они издавали громкий и необычный звук «ко-кокк». Машины тут же расступались, у водителей сносило «кукушку».</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },
    '2b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Спецсигналы в дореволюционной России, которые были установлены на пожарных и полицейских машинах, а также на фельдъегерских тройках, звучали как...</a></p>`,
      answerList: [
        ['Электровибрационный сигнал, получивший прозвище «кукушка».', false],
        ['Особый звон колокольчиков.', 'selected'],
        ['Медный гудок с резиновой «грушей».', false],
      ],
      comment: `<p>Умница! Видимо, читали книги Гиляровского. Помните, как у писателя и краеведа пешеходы и повозки спешно разбегались с дороги, когда слышали особый звон колокольчиков?</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '3'
    },
    '2c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-2c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Спецсигналы в дореволюционной России, которые были установлены на пожарных и полицейских машинах, а также на фельдъегерских тройках, звучали как...</a></p>`,
      answerList: [
        ['Электровибрационный сигнал, получивший прозвище «кукушка».', false],
        ['Особый звон колокольчиков.', false],
        ['Медный гудок с резиновой «грушей».', 'selected']
      ],
      comment: `<p>Вы промахнулись! Пресловутая «крякалка», выглядевшая как медная труба с резиновой «грушей», появилась уже после революции.</a></p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '2'
    },

    '3': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-3.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком городе СССР был установлен первый автоматический светофор?</p>`,
      answers: [
        {
          title: 'А.   В Ленинграде на углу Невского и Литейного проспектов.',
          next: '3a'
        },
        {
          title: 'В Москве на углу Петровки и Кузнецкого моста.',
          next: '3b'
        },
        {
          title: 'В Харькове.',
          next: '3c'
        },
      ],
    },
    '3a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком городе СССР был установлен первый автоматический светофор?</p>`,
      answerList: [
        ['В Ленинграде на углу Невского и Литейного проспектов.', 'selected'],
        ['В Москве на углу Петровки и Кузнецкого моста.', false],
        ['В Харькове.', false],
      ],
      comment: `<p>Попали в яблочко! И наверняка знаете, что «трехглазый друг пешеходов» появился на пересечении проспектов 25 Октября и Володарского (как тогда именовались Невский и Литейный проспекты) аккурат 15 января 1930 года. Причем изначально вместо зеленого цвета применялся синий.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '4'
    },
    '3b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком городе СССР был установлен первый автоматический светофор?</p>`,
      answerList: [
        ['А.   В Ленинграде на углу Невского и Литейного проспектов.', false],
        ['В Москве на углу Петровки и Кузнецкого моста.', 'selected'],
        ['В Харькове.', false],
      ],
      comment: `<p>Вы промахнулись! В столице первый светофор появился лишь 30 декабря 1930-го. Кстати, вам любопытно будет узнать, что в рамках <a href="http://dorogi2020.bkdrf.ru/?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">национального проекта «Безопасные и качественные автомобильные дороги»</a> во всех уголках России  к 2024 году появятся «умные» системы контроля трафика, современные светофоры и новое освещение.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },
    '3c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-3c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком городе СССР был установлен первый автоматический светофор?</p>`,
      answerList: [
        ['А.   В Ленинграде на углу Невского и Литейного проспектов.', false],
        ['В Москве на углу Петровки и Кузнецкого моста.', false],
        ['В Харькове.', 'selected'],
      ],
      comment: `<p>В Харькове первый светофор был установлен только в 1936 году.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '3'
    },

    '4': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-4.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая из федеральных трасс самая длинная?</p>`,
      answers: [
        {
          title: 'Трасса Р297 «Амур».',
          next: '4a'
        },
        {
          title: 'Трасса М4 «Дон».',
          next: '4b'
        },
        {
          title: 'Трасса М5 «Урал».',
          next: '4c'
        },
      ],
    },
    '4a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая из федеральных трасс самая длинная?</p>`,
      answerList: [
        ['Трасса Р297 «Амур».', 'selected'],
        ['Трасса М4 «Дон».', false],
        ['Трасса М5 «Урал».', false],
      ],
      comment: `<p>Вы промазали. Хотя трасса «Амур», которая соединяет Читу и Хабаровск, тоже довольно протяженная, ее длина – 2165 километров.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая из федеральных трасс самая длинная?</p>`,
      answerList: [
        ['Трасса Р297 «Амур».', false],
        ['Трасса М4 «Дон».', 'selected'],
        ['Трасса М5 «Урал».', false],
      ],
      comment: `<p>Не угадали! Чтобы добраться из Москвы до Новороссийска по трассе «Дон», потребуется преодолеть 1543 километра. Но есть и более протяженные трассы.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '4'
    },
    '4c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-4c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая из федеральных трасс самая длинная?</p>`,
      answerList: [
        ['Трасса Р297 «Амур».', false],
        ['Трасса М4 «Дон».', false],
        ['Трасса М5 «Урал».', 'selected'],
      ],
      comment: `<p>Как вы прозорливы! Трасса «Урал», которая соединяет Москву и Екатеринбург, одно из главных восточных направлений России. Общая длина этого пути вместе с ответвлениями составляет 2986 километров. Это еще и самая перегруженная федеральная трасса РФ. Благодаря национальному проекту «Безопасные и качественные автомобильные дороги» к 2024 году <a href="https://bkdrf.ru/map?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">сократится протяженность автодорог федерального и регионального значения</a>, работающих в режиме перегрузки на 10%.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '5'
    },

    '5': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-5.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Назовите самый длинный автомобильный тоннель России. </p>`,
      answers: [
        {
          title: 'Лефортовский автомобильный тоннель.',
          next: '5a'
        },
        {
          title: 'Рокский автодорожный тоннель.',
          next: '5b'
        },
        {
          title: 'Гимринский автодорожный тоннель.',
          next: '5c'
        },
      ],
    },
    '5a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Назовите самый длинный автомобильный тоннель России. </p>`,
      answerList: [
        ['Лефортовский автомобильный тоннель.', 'selected'],
        ['Рокский автодорожный тоннель.', false],
        ['Гимринский автодорожный тоннель.', false],
      ],
      comment: `<p>Нет, нет, не все самое большое, длинное и высокое достается столице. Эта подземная магистраль длиной 3240 метров пролегает в Москве под Лефортовским парком и рекой Яузой. Но Лефортовский тоннель все-таки не самый длинный в России.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Назовите самый длинный автомобильный тоннель России. </p>`,
      answerList: [
        ['Лефортовский автомобильный тоннель.', false],
        ['Рокский автодорожный тоннель.', 'selected'],
        ['Гимринский автодорожный тоннель.', false],
      ],
      comment: `<p>Вы явно сбились с пути. Рокский тоннель проложен под горой Сохс между Северной и Южной Осетией. Его протяженность – 3660 метров, но есть и более длинный каменный «коридор».</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '5'
    },
    '5c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-5c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Назовите самый длинный автомобильный тоннель России. </p>`,
      answerList: [
        ['Лефортовский автомобильный тоннель.', false],
        ['Рокский автодорожный тоннель.', false],
        ['Гимринский автодорожный тоннель.', 'selected'],
      ],
      comment: `<p>Его длина – 4303 метра. Он проложен на глубине 900 метров в толще Гимринского хребта между Буйнакском и селом Гимры. Транспортная артерия соединяет 9 горных районов Дагестана с железной дорогой и Махачкалой. Важно, что приведению автомобильных дорог регионального значения в нормативное состояние уделяется пристальное внимание в рамках <a href="https://bkdrf.ru/about20?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">нацпроекта «Безопасные и качественные автомобильные дороги».</a></p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '6'
    },

    '6': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-6.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Что изображено на дорожном знаке «Место отдыха»?</p>`,
      answers: [
        {
          title: 'Хвойное дерево.',
          next: '6a'
        },
        {
          title: 'Лиственное дерево.',
          next: '6b'
        },
        {
          title: 'Три дерева.',
          next: '6c'
        },
      ],
    },
    '6a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Что изображено на дорожном знаке «Место отдыха»?</p>`,
      answerList: [
        ['Хвойное дерево.', 'selected'],
        ['Лиственное дерево.', false],
        ['Три дерева.', false],
      ],
      comment: `<p>Как вы наблюдательны! На дорожном знаке «Место отдыха» изображена ель. А знаете ли вы, что в рамках <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/bezopasnye-i-kachestvennye-avtomobilnye-dorogi?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">национального проекта «Безопасные и качественные автомобильные дороги»</a> в 2020 году уже установили более 2 тыс. светофоров и более 160 тыс. дорожных знаков.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '7'
    },
    '6b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Что изображено на дорожном знаке «Место отдыха»?</p>`,
      answerList: [
        ['Хвойное дерево.', false],
        ['Лиственное дерево.', 'selected'],
        ['Три дерева.', false],
      ],
      comment: `<p>Вы «сели в лужу». Остается петь: «Там, где клен шумит» или «Вы шумите, березы».</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },
    '6c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-6c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Что изображено на дорожном знаке «Место отдыха»?</p>`,
      answerList: [
        ['Хвойное дерево.', false],
        ['Лиственное дерево.', false],
        ['Три дерева.', 'selected'],
      ],
      comment: `<p>Вы оплошали! Ассоциации ваши понятны: три богатыря, три толстяка, три белых коня, три девицы под окном… Опять же можно сообразить на троих. И тогда может троиться в глазах.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '6'
    },

    '7': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-7.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>К какому цвету наши глаза особенно чувствительны?</p>`,
      answers: [
        {
          title: 'К желтому.',
          next: '7a'
        },
        {
          title: 'К зеленому.',
          next: '7b'
        },
        {
          title: 'К красному.',
          next: '7c'
        },
      ],
    },
    '7a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-7a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>К какому цвету наши глаза особенно чувствительны?</p>`,
      answerList: [
        ['К желтому.', 'selected'],
        ['К зеленому.', false],
        ['К красному.', false],
      ],
      comment: `<p>Именно по этой причине на многих знаках применяется желтый цвет. Например, знак «Аварийно-опасный участок дороги» изображен на желтом фоне, а указатель «Пешеходный переход» обрамлен в желтую рамку.  Желтый цвет бросается в глаза, пешеходы и водители замечают такие знаки на порядок быстрее.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '8'
    },
    '7b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-7b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>К какому цвету наши глаза особенно чувствительны?</p>`,
      answerList: [
        ['К желтому.', false],
        ['К зеленому.', 'selected'],
        ['К красному.', false],
      ],
      comment: `<p>Промашка вышла! Но мы вас понимаем, дело к Новому году. Все мысли о елке, горошке, огурчике и никакой зеленой тоски!</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '7'
    },
    '7c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-7c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>К какому цвету наши глаза особенно чувствительны?</p>`,
      answerList: [
        ['К желтому.', false],
        ['К зеленому.', false],
        ['К красному.', 'selected'],
      ],
      comment: `<p>Вы пролетели! Но мы с вами заодно, сейчас бы прыгнуть в красный «Феррари», смолотить шоколадку с «Красного Октября» и рвануть на Красное море!</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '7'
    },

    '8': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-8.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какого кузова автомобиля не существует?</p>`,
      answers: [
        {
          title: 'Это фаэтон.',
          next: '8a'
        },
        {
          title: 'Это брогам.',
          next: '8b'
        },
        {
          title: 'Это шарабан.',
          next: '8c'
        },
      ],
    },
    '8a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-8a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какого кузова автомобиля не существует?</p>`,
      answerList: [
        ['Это фаэтон.', 'selected'],
        ['Это брогам.', false],
        ['Это шарабан.', false],
      ],
      comment: `<p>Вам крышка, вернее – автопокрышка! Фаэтон – это автомобиль открытого типа с 4 дверями, с откидным или съемным верхом. Признайтесь, хотели бы сейчас прокатиться на нем с ветерком?</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '8'
    },
    '8b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-8b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какого кузова автомобиля не существует?</p>`,
      answerList: [
        ['Это фаэтон.', false],
        ['Это брогам.', 'selected'],
        ['Это шарабан.', false],
      ],
      comment: `<p>Жмите на тормоз, приехали. Брогам – тип кузова, имеющий складную крышу над передними сиденьями.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '8'
    },
    '8c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-8c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какого кузова автомобиля не существует?</p>`,
      answerList: [
        ['Это фаэтон.', false],
        ['Это брогам.', false],
        ['Это шарабан.', 'selected'],
      ],
      comment: `<p>Вы правы, такого типа кузова автомобиля не существует. Шарабан – это открытый легкий двухконный экипаж. Признайтесь, представили пассажиров с гусями в корзинах? Или это были барышни, прикрывающие лицо ажурным зонтиком?</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '9'
    },

    '9': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-9.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком произведении еще в 1958 году подробно была описана телевизионная система наблюдения за уличным движением?</p>`,
      answers: [
        {
          title: 'В научно-фантастическом романе Ивана Ефремова «Час Быка».',
          next: '9a'
        },
        {
          title: 'В футуристической утопии Николая Носова «Незнайка в Солнечном городе».',
          next: '9b'
        },
        {
          title: 'В научно-фантастическом романе Александра Беляева «Голова профессора Доуэля».',
          next: '9c'
        },
      ],
    },
    '9a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-9a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком произведении еще в 1958 году подробно была описана телевизионная система наблюдения за уличным движением?</p>`,
      answerList: [
        ['В научно-фантастическом романе Ивана Ефремова «Час Быка».', 'selected'],
        ['В футуристической утопии Николая Носова «Незнайка в Солнечном городе».', false],
        ['В научно-фантастическом романе Александра Беляева «Голова профессора Доуэля».', false],
      ],
      comment: `<p>Вы потерялись во времени. Роман «Час Быка» о том, как может складываться наше далекое будущее, был написан в 1968 году.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '9'
    },
    '9b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-9b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком произведении еще в 1958 году подробно была описана телевизионная система наблюдения за уличным движением?</p>`,
      answerList: [
        ['В научно-фантастическом романе Ивана Ефремова «Час Быка».', false],
        ['В футуристической утопии Николая Носова «Незнайка в Солнечном городе».', 'selected'],
        ['В научно-фантастическом романе Александра Беляева «Голова профессора Доуэля».', false],
      ],
      comment: `<p>Вы вовремя впали в детство! Ох уж этот технологичный Солнечный город, где для наблюдения за общественным порядком все перекрестки в городе оборудованы системами видеонаблюдения. Писатель предугадал будущее. Ныне в рамках <a href="http://dorogi2020.bkdrf.ru/?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">национального проекта</a> большое внимание уделяется интеллектуальным системам контроля трафика, растет число камер фотовидеофиксации. С помощью специальной системы будет взят под контроль режим работы профессиональных водителей. В итоге  к 2024 году смертность в ДТП на дорогах должна сократиться в 3,5 раза.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: '10'
    },
    '9c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-9c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>В каком произведении еще в 1958 году подробно была описана телевизионная система наблюдения за уличным движением?</p>`,
      answerList: [
        ['В научно-фантастическом романе Ивана Ефремова «Час Быка».', false],
        ['В футуристической утопии Николая Носова «Незнайка в Солнечном городе».', false],
        ['В научно-фантастическом романе Александра Беляева «Голова профессора Доуэля».', 'selected'],
      ],
      comment: `<p>Вам нужно переместиться на три десятка лет вперед. Это произведение, где описываются работы по оживлению человеческой головы, было написано в 1925 году.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '9'
    },

    '10': {
      type: 'simple-question',
      isMultiple: false,
      imageSrc: './assets/photo/tutorial-10.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая технология сейчас используется, чтобы четко была видна «зебра» на пешеходном переходе? </p>`,
      answers: [
        {
          title: 'Устанавливаются мощные лазерные проекторы, транслирующие изображение «зебры» на дорогу.',
          next: '10a'
        },
        {
          title: 'В краску для нанесения разметки добавляют биолюминесцентные водоросли, которые светятся в темноте.',
          next: '10b'
        },
        {
          title: 'Использование классической технологии 3D-печати из специального состава на основе бетона и полимерных смол.',
          next: '10c'
        },
      ],
    },
    '10a': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-10a.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая технология сейчас используется, чтобы четко была видна «зебра» на пешеходном переходе? </p>`,
      answerList: [
        ['Устанавливаются мощные лазерные проекторы, транслирующие изображение «зебры» на дорогу.', 'selected'],
        ['В краску для нанесения разметки добавляют биолюминесцентные водоросли, которые светятся в темноте.', false],
        ['Использование классической технологии 3D-печати из специального состава на основе бетона и полимерных смол.', false],
      ],
      comment: `<p>Умница! Такая разметка не стирается колесами, ее не заносит снегом. В темноте проекционная «зебра» выглядит как космолет. Водители, естественно, заранее сбрасывают скорость. Вам на заметку: <a href="https://xn--80aapampemcchfmo7a3c9ehj.xn--p1ai/projects/bezopasnye-i-kachestvennye-avtomobilnye-dorogi?utm_source=MK_spec&utm_medium=Statica&utm_content=All&utm_campaign=bezopasnye-i-kachestvennye-avtomobilnye-dorogi" target="_blank" rel="noopener noreferrer">в национальном проекте «Безопасные и качественные автомобильные дороги»</a> большое внимание уделяется безопасности дорожного движения, поэтому на дорогах появляется качественная современная разметка, освещение и применяются суперсовременные технологии.</p>`,
      button: true,
      buttonText: 'Идем дальше',
      specialClass: 'content__step_right',
      next: 'finish'
    },
    '10b': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-10b.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая технология сейчас используется, чтобы четко была видна «зебра» на пешеходном переходе? </p>`,
      answerList: [
        ['Устанавливаются мощные лазерные проекторы, транслирующие изображение «зебры» на дорогу.', false],
        ['В краску для нанесения разметки добавляют биолюминесцентные водоросли, которые светятся в темноте.', 'selected'],
        ['Использование классической технологии 3D-печати из специального состава на основе бетона и полимерных смол.', false],
      ],
      comment: `<p>Водоросли типа Noctiluca scintillans действительно светятся в темноте, реагируют на любые движения, рокот волн или плеск весел. Но сильное сияние они способны создавать только в океане! </p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '10'
    },
    '10c': {
      type: 'comment',
      imageSrc: './assets/photo/tutorial-10c.png',
      imageAuthor: ``,
      description: `<h2 class="content__title">Вопрос:</h2><p>Какая технология сейчас используется, чтобы четко была видна «зебра» на пешеходном переходе? </p>`,
      answerList: [
        ['Устанавливаются мощные лазерные проекторы, транслирующие изображение «зебры» на дорогу.', false],
        ['В краску для нанесения разметки добавляют биолюминесцентные водоросли, которые светятся в темноте.', false],
        ['Использование классической технологии 3D-печати из специального состава на основе бетона и полимерных смол.', 'selected'],
      ],
      comment: `<p>Транспортная революция еще впереди! Но над подобными проектами с использованием промышленного 3D-принтера для печати автомобильных дорог ученые уже работают.</p>`,
      button: true,
      buttonText: 'Вернитесь на шаг назад',
      specialClass: 'content__step_wrong',
      next: '10'
    },

    'finish': {
      type: 'comment',
      imageSrc: './assets/photo/final.png',
      imageAuthor: '',
      description: `
        <style>.content__answer-list{display:none}.last__bottom-link{text-align:center;margin-bottom:20px;color:#333;font-size:16px;font-weight:400}</style>
        <h2 class="content__title">Поздравляем!</h2>
        <p>Все! Вы на финише! Жмите на тормоз. Надеемся, что вам с нами было интересно! Узнать больше о национальном проекте «Безопасные и качественные автомобильные дороги»  и других проектах вы сможете на сайте «Национальные проекты РФ» и <a href="https://www.mk.ru/stories/putevoditel-po-nacionalnym-proektam-rossii/" target="_blank" rel="noopener noreferrer">в специальном сюжете «МК».</a></p>`,
      button: true,
      buttonText: 'Играть с начала',
      shareButton: {classNames: {mainWraper: 'last__share', linkItem: 'last__share-button'}},
      endingScreen: true,
      specialClass: 'content__step_finish',
      next: '1',
      textAfter: `
        <div class="text-after">
          <ul class="text-after__list">
            <li class="text-after__item">
              <a href="https://www.mk.ru/social/2020/12/14/sovremennye-tekhnologii-na-strazhe-bezopasnosti-dorozhnogo-dvizheniya.html" target="_blank" rel="noopener noreferrer">
                <svg class="" width="65" height="65">
                  <use class="content__logo-picture" xlink:href="#icon-highways"></use>
                </svg>

                <span class="text-after__item-text">Автодороги</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/nacputevoditeli/#ecology" target="_blank" rel="noopener noreferrer">
                <svg class="" width="65" height="65">
                  <use class="content__logo-picture" xlink:href="#icon-ecology"></use>
                </svg>

                <span class="text-after__item-text">Экология</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/nacputevoditeli/#education" target="_blank" rel="noopener noreferrer">
                <svg class="" width="65" height="65">
                  <use class="content__logo-picture" xlink:href="#icon-education"></use>
                </svg>

                <span class="text-after__item-text">Образование</span>
              </a>
            </li>
            <li class="text-after__item">
              <a href="https://www.mk.ru/projects/nacputevoditeli/#demography" target="_blank" rel="noopener noreferrer">
                <svg class="" width="65" height="65">
                  <use class="content__logo-picture" xlink:href="#icon-demography"></use>
                </svg>

                <span class="text-after__item-text">Демография</span>
              </a>
            </li>
          </ul>
        </div>
      `,
    }
  }
}];

createOrder(GAME_1[0].steps, QUESTIONS_NUMBER, questionsArray);

export const jsonAnswerMock1 = JSON.stringify(GAME_1);



// WEBPACK FOOTER //
// ./data/get-mock-data.js